/**
 * useViewport - tiny hook that reports the viewport breakpoint without bringing
 * in a new dependency. Used by the v2 chrome to switch between desktop sidebar
 * and a mobile drawer.
 */
import { useState, useEffect } from "react";

export function useViewport() {
  const [w, setW] = useState(typeof window === "undefined" ? 1280 : window.innerWidth);

  useEffect(() => {
    if (typeof window === "undefined") return undefined;
    const onResize = () => setW(window.innerWidth);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  return {
    width: w,
    isMobile:  w < 768,
    isTablet:  w >= 768 && w < 1100,
    isDesktop: w >= 1100,
  };
}
